import React from 'react';
import './RadioElement.scss';
function RadioElement(_a) {
    var name = _a.name, value = _a.value, disabled = _a.disabled, onChange = _a.onChange, checked = _a.checked;
    return (React.createElement("span", { className: "elmo-radio__element" },
        React.createElement("input", { type: "radio", name: name, value: value, disabled: disabled, tabIndex: -1, onChange: onChange, checked: checked }),
        React.createElement("span", { className: "elmo-radio__icon" })));
}
export default RadioElement;
